import { Component, Input, Output, EventEmitter, HostListener, OnChanges, SimpleChanges } from '@angular/core';
import { getParaStudentDisplayGrade, getParaStudentDisplayName } from '../../utils/para-student-display.util';
import type { ParaStudentBadgeMilestoneOverlay } from '../../progress-table/para-milestone.util';

@Component({
	selector: 'app-para-drawer',
	templateUrl: './para-drawer.component.html',
	styleUrls: ['./para-drawer.component.css'],
})
export class ParaDrawerComponent {
	@Input() isOpen = false;

	/** Drawer header context (required for header + badge). */
	@Input() student: any | null = null;

	/** Highest achieved milestone tier for compact badge overlap (PARA progress / LMS header). */
	@Input() studentBadgeMilestoneOverlay: ParaStudentBadgeMilestoneOverlay | null = null;

	/** When true, reserve a middle header column (e.g. LMS challenge progress). */
	@Input() showHeaderCenter = false;

	@Output() close = new EventEmitter<void>();

	/** Keep the drawer mounted while animating out. */
	public rendered = false;
	/** Drives CSS transitions; toggled a tick after mount. */
	public opened = false;

	ngOnChanges(changes: SimpleChanges): void {
		if (!('isOpen' in changes)) return;

		if (this.isOpen) {
			this.rendered = true;
			// Ensure initial "closed" state is painted before transitioning open.
			queueMicrotask(() => {
				if (this.isOpen) this.opened = true;
			});
			return;
		}

		this.opened = false;
		// Match CSS transition duration (0.4s) with a small buffer.
		setTimeout(() => {
			if (!this.isOpen) {
				this.rendered = false;
			}
		}, 420);
	}

	@HostListener('document:keydown.escape')
	onEscape(): void {
		if (this.rendered) {
			this.close.emit();
		}
	}

	onClose(): void {
		this.close.emit();
	}

	get resolvedStudentName(): string {
		return getParaStudentDisplayName(this.student);
	}

	get resolvedStudentGrade(): string {
		return getParaStudentDisplayGrade(this.student);
	}
}
